module.exports = __webpack_public_path__ + "img/sq5d_05.dc8a9eb5.jpg";